import { render, staticRenderFns } from "./EmailListModal.vue?vue&type=template&id=5aab1960&"
import script from "./EmailListModal.vue?vue&type=script&lang=ts&"
export * from "./EmailListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports